<template>
  <section class="section">
    <div class="mt-100 container mt-60">
      <div class="row">
        <div class="col-12 text-center">
          <div class="section-title mb-4 pb-2">
            <h4 class="title mb-3">
              Puerto Antioquia - Registro <span v-show="type == 'anonimo'">anónimo</span> de PQRSR
            </h4>
            <div class="mx-auto col-sm-12 col-md-8">
              <p>
                Puerto Bahía Colombia de Urabá S.A.- Puerto Antioquia, implementa un Procedimiento para la atención
                oportuna de Peticiones, Quejas, Reclamos, Sugerencias o Recomendaciones, generando así una
                alternativa para gestionar las solicitudes del público en general, mediante un proceso comprensible
                y accesible.
              </p>
              <p>
                Para iniciar la gestión de la solicitud, por favor diligencie el presente formulario. Tenga en
                cuenta que con este registro usted certifica que la información contenida y/o adjuntada son copias
                verdaderas y correctas. Adicionalmente, autoriza a Puerto Bahía Colombia de Urabá S.A. el manejo de
                los datos, con la confidencialidad y protección que la ley exige.
              </p>
              <p>En Puerto Antioquia también estamos disponibles para atenderle en:</p>
            </div>
            <div class="mx-auto col-md-8 col-sm-12">
              <div class="row">
                <div class="col-lg-6">
                  <p>
                    Oficina administrativa: Edificio Cámara de Comercio de Urabá, piso 8 Apartadó, Antioquia
                    Horarios de Atención: Lunes a viernes, de 7:00.a.m. a 5:00.p.m. Teléfono: (+57 - 4) 828 32 83
                    Correo electrónico:
                    <a href="mailto:info@puerto-antioquia.com">info@puerto-antioquia.com</a>
                  </p>
                </div>
                <div class="col-lg-6">
                  <p>
                    Oficinas de Atención a la Comunidad: Biblioteca Pública Fundación Unibán Nueva Colonia, Turbo,
                    Antioquia Horarios de Atención: Lunes a viernes, de 7:00.a.m. a 5:00.p.m. y Sábados de
                    8:00.a.m. a 1:00.p.m. Correo electrónico:
                    <a href="mailto:notificaciones@puertoantioquia.com.co"
                      >notificaciones@puertoantioquia.com.co</a
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end col-->
      </div>
      <!--end row-->

      <div class="row justify-content-center">
        <div class="col-md-8 mt-4 pt-2">
          <div class="custom-form">
            <div id="message"></div>
            <div v-show="finish" class="alert alert-info">
              <h3>{{ finishMessage }}</h3>
              <p>Gracias por usar nuestro servicio.</p>
            </div>
            <div v-if="!finish">
              <div class="row">
                <div class="col-md-8" v-show="type == 'normal'">
                  <div class="form-group">
                    <label class="form-label">Correo electrónico<span class="text-danger"> *</span> :</label>
                    <input
                      v-model="form.email"
                      name="email"
                      id="email"
                      type="email"
                      class="form-control"
                      placeholder="Su correo :"
                    />
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="form-group">
                    <label class="form-label">Tipo de Solicitud<span class="text-danger"> *</span> :</label>
                    <select
                      v-model="form.tipo_solicitud"
                      class="form-select form-control"
                      aria-label="Tipo de solicitud"
                      placeholder="Elegir"
                    >
                      <option value="Peticion">Petición</option>
                      <option value="Queja">Queja</option>
                      <option value="Reclamo">Reclamo</option>
                      <option value="Sugerencia">Sugerencia</option>
                      <option value="Recomendacion">Recomendación</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="form-label"
                      >Medio para notificarle la respuesta<span class="text-danger"> *</span> :</label
                    >
                    <div class="form-check" v-for="(item, index) in filterMedioOptions" :key="index">
                      <input
                        class="form-check-input"
                        type="radio"
                        :id="'opt' + index"
                        :value="item.value"
                        v-model="form.medio"
                      />
                      <label class="form-check-label" :for="'opt' + index">{{ item.label }} </label>
                    </div>
                    <div class="form-check" key="otros">
                      <input class="form-check-input mt-2" type="radio" id="medio-otros" v-model="form.medio" />
                      <div class="d-flex">
                        <label class="form-check-label mt-1" for="medio-otros">Otro medio:</label>
                        <input
                          name="medio-otro"
                          id="medio-otro"
                          type="text"
                          class="form-control-sm ms-1"
                          placeholder=""
                          v-model="form.otros_medio"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12" v-show="type == 'normal'">
                  <div class="alert alert-grey">
                    <b class="block">Identificación del Solicitante</b>
                    <small>
                      Dando cumplimiento al Decreto 1377 reglamentario de la Ley 1581 de 2012 sobre Protección de
                      Datos, el solicitante autoriza a la Sociedad Puerto Bahía Colombia de Urabá S.A, identificada
                      con el NIT. 900.188.593-8 domiciliada en la ciudad de Apartadó, con página web
                      <a href="www.puertoantioquia.com.co">www.puertoantioquia.com.co</a> y teléfono (+57) (4)
                      8283283, para tratar su información personal con las finalidades establecidas en la POLÍTICA
                      DE PROTECCIÓN DE DATOS PERSONALES.
                    </small>
                  </div>
                </div>
                <div class="col-md-12" v-show="type == 'normal'">
                  <div class="form-group">
                    <label class="form-label">Nombre completo <span class="text-danger"> *</span> :</label>
                    <input
                      v-model="form.nombres"
                      name="name"
                      id="name"
                      type="text"
                      class="form-control"
                      placeholder="Su Nombre :"
                    />
                  </div>
                </div>
                <div class="col-md-12" v-show="type == 'normal'">
                  <div class="form-group">
                    <label class="form-label"> Teléfono de contacto <span class="text-danger"> *</span> :</label>
                    <input
                      v-model="form.telefono"
                      name="phone"
                      id="phone"
                      type="text"
                      class="form-control"
                      placeholder="Su Teléfono :"
                    />
                  </div>
                </div>
                <!--end col-->
                <div class="col-md-12">
                  <div class="alert alert-grey">
                    <b class="block">Caracterización del solicitante</b>
                    <small>
                      En Puerto Antioquia nos interesa consolidar información estadística que permita identificar
                      tendencias y estructurar Planes de Acción o Prevención Colectivos. Por esto, le agradecemos
                      responder las siguientes preguntas.
                    </small>
                  </div>
                </div>
                <!--end col-->
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="form-label"
                      >Género con el que se identifica<span class="text-danger"> *</span> :</label
                    >
                    <div class="form-check" v-for="(item, index) in options.genero" :key="index">
                      <input
                        class="form-check-input"
                        type="radio"
                        :id="'gen' + index"
                        :value="item.value"
                        v-model="form.genero"
                      />
                      <label class="form-check-label" :for="'gen' + index">{{ item.label }} </label>
                    </div>
                    <div class="form-check" key="otros">
                      <input class="form-check-input mt-2" type="radio" id="genero-otros" v-model="form.genero" />
                      <div class="d-flex">
                        <label class="form-check-label mt-1" for="genero-otros">Otros:</label>
                        <input
                          name="genero-otro"
                          id="genero-otro"
                          type="text"
                          class="form-control-sm ms-1"
                          placeholder=""
                          v-model="form.otros_genero"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <!--end col-->
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="form-label"
                      >Grupo de interés al que pertenece<span class="text-danger"> *</span> :</label
                    >
                    <div class="form-check" v-for="(item, index) in options.grupointeres" :key="index">
                      <input
                        class="form-check-input"
                        type="radio"
                        :id="'interes' + index"
                        :value="item.value"
                        v-model="form.grupointeres"
                      />
                      <label class="form-check-label" :for="'interes' + index">{{ item.label }} </label>
                    </div>
                    <div class="form-check" key="otros">
                      <input
                        class="form-check-input mt-2"
                        type="radio"
                        id="grupointeres-otros"
                        v-model="form.grupointeres"
                      />
                      <div class="d-flex">
                        <label class="form-check-label mt-1" for="grupointeres-otros">Otros:</label>
                        <input
                          name="grupointeres-otro"
                          id="grupointeres-otro"
                          type="text"
                          class="form-control-sm ms-1"
                          placeholder=""
                          v-model="form.otros_grupointeres"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <!--end col-->
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="form-label">Describa su solicitud <span class="text-danger"> *</span> :</label>
                    <textarea
                      v-model="form.solicitud"
                      name="solicitud"
                      id="solicitud"
                      rows="3"
                      class="form-control"
                      placeholder="Tu Respuesta :"
                    ></textarea>
                  </div>
                </div>
                <!--end col-->
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="form-label">Sugerencia :</label>
                    <textarea
                      v-model="form.sugerencia"
                      name="sugerencia"
                      id="sugerencia"
                      rows="2"
                      class="form-control"
                      placeholder="Tu Respuesta :"
                    ></textarea>
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="form-group">
                    <label class="form-label">Adjunto de soportes y evidencias :</label>
                    <input
                      @change="handleFileUpload($event)"
                      name="files"
                      id="files"
                      type="file"
                      ref="file"
                      class="form-control"
                      style="height: 38px"
                    />
                  </div>
                </div>
              </div>
              <!--end row-->
              <div class="row">
                <div class="col-sm-12">
                  <ul>
                    <li class="text-danger" v-for="(item, index) in errors" :key="index">{{ item[0] }}</li>
                  </ul>
                  <div v-show="generalError" class="alert alert-danger py-2">{{ generalError }}</div>
                </div>
                <div class="col-sm-12 d-grid">
                  <button class="btn btn-primary" @click="store()" :disabled="loading.store">
                    <i v-show="loading.store" class="fal fa-circle-notch fa-spin"></i
                    ><span class="ms-1">Enviar</span>
                  </button>
                  <div id="simple-msg"></div>
                </div>
                <!--end col-->
              </div>
              <!--end row-->
            </div>
            <!--end form-->
          </div>
          <!--end custom-form-->
        </div>
        <!--end col-->
      </div>
      <!--end row-->
    </div>
    <!--end container-->
  </section>
</template>

<script>
export default {
  name: 'FormPqrs',
  props: {
    type: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      form: {
        medio: '',
        email: '',
        otros_medio: '',
        tipo_solicitud: '',
        nombres: '',
        telefono: '',
        genero: '',
        otros_genero: '',
        grupointeres: '',
        otros_grupointeres: '',
        solicitud: '',
        sugerencia: '',
        files: null,
      },
      options: {
        medio: [
          { label: 'Comunicado público', value: 'Comunicado público', type: 'mix' },
          { label: 'Publicación en carteleras', value: 'Publicación en carteleras', type: 'mix' },
          { label: 'Publicación en sitio web', value: 'Publicación en sitio web', type: 'mix' },
          { label: 'Correo electrónico', value: 'Correo electrónico', type: 'normal' },
          { label: 'Llamada telefónica', value: 'Llamada telefónica', type: 'normal' },
        ],
        genero: [
          { label: 'Femenino', value: 'Femenino' },
          { label: 'Masculino', value: 'Masculino' },
          { label: 'Prefiero no decirlo', value: 'Prefiero no decirlo' },
        ],
        grupointeres: [
          {
            label: 'Asociación de Pescadores y Acuicultores de Nueva Colonia - APEANCO',
            value: 'Asociación de Pescadores y Acuicultores de Nueva Colonia - APEANCO',
          },
          { label: 'Asopescatur', value: 'Asopescatur' },
          { label: 'Comité Técnico Territorial y Comunitario', value: 'Comité Técnico Territorial y Comunitario' },
          { label: 'Comunidad de Apartadó', value: 'Comunidad de Apartadó' },
          { label: 'Comunidad del Distrito de Turbo- Urbano', value: 'Comunidad del Distrito de Turbo- Urbano' },
          { label: 'Comunidad de Nueva Colonia', value: 'Comunidad de Nueva Colonia' },
          { label: 'Comunidad de Riogrande', value: 'Comunidad de Riogrande' },
          { label: 'Consultor', value: 'Consultor' },
          { label: 'Equipo de Consorcio COTEMA', value: 'Equipo de Consorcio COTEMA' },
          { label: 'Equipo de Consorcio MIIT', value: 'Equipo de Consorcio MIIT' },
          { label: 'Equipo de Puerto Antioquia', value: 'Equipo de Puerto Antioquia' },
          {
            label: 'Consejo Mayor de Comunidades Negras de Nueva Colonia - COMANUCO',
            value: 'Consejo Mayor de Comunidades Negras de Nueva Colonia - COMANUCO',
          },
          { label: 'Consejo Comunitario Puerto Girón', value: 'Consejo Comunitario Puerto Girón' },
          { label: 'Mesa de Trabajo de Riogrande', value: 'Mesa de Trabajo de Riogrande' },
          { label: 'Proveedor', value: 'Proveedor' },
          { label: 'Subcontratista', value: 'Subcontratista' },
        ],
      },
      stored: {},
      errors: {},
      generalError: '',
      finish: false,
      finishMessage: '',
      loading: {
        store: false,
      },
    }
  },
  methods: {
    handleFileUpload() {
      this.form.files = this.$refs.file.files[0]
    },
    finishForm(message) {
      this.finish = true
      this.finishMessage = message
      this.form = {
        medio: null,
        email: null,
        otros_medio: null,
        tipo_solicitud: null,
        nombres: null,
        telefono: null,
        genero: null,
        otros_genero: null,
        grupointeres: null,
        otros_grupointeres: null,
        solicitud: null,
        sugerencia: null,
        files: null,
      }
    },
    store() {
      const self = this
      self.loading.store = true
      self.errors = {}
      self.generalError = ''

      let formData = new FormData()

      formData.append('type', self.type)
      formData.append('email', self.form.email)
      formData.append('medio', self.com_medio)
      formData.append('tipo_solicitud', self.form.tipo_solicitud)
      formData.append('nombres', self.form.nombres)
      formData.append('telefono', self.form.telefono)
      formData.append('genero', self.com_genero)
      formData.append('grupointeres', self.com_grupointeres)
      formData.append('solicitud', self.form.solicitud)
      formData.append('sugerencia', self.form.sugerencia)
      if (self.form.files) {
        formData.append('files', self.form.files)
      }

      axios
        .post('/pqrs', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => {
          if (res.data.success) {
            self.stored = res.data.data
            self.finishForm(res.data.message)
          }
        })
        .catch((e) => {
          if (e.response && e.response.status === 422 && e.response.data && e.response.data.errors) {
            self.errors = e.response.data.errors
          } else if (e.response && e.response.status === 429) {
            self.generalError = 'Has enviado demasiadas solicitudes. Espera un momento e inténtalo de nuevo.'
          } else {
            self.generalError =
              'No pudimos enviar tu solicitud. Revisa tu conexión e inténtalo de nuevo en unos minutos.'
          }
        })
        .finally(() => {
          self.loading.store = false
        })
    },
  },
  computed: {
    filterMedioOptions() {
      if (this.type == 'anonimo') {
        return this.options.medio.filter((element) => element.type == 'mix')
      }
      return this.options.medio
    },
    com_medio() {
      if (this.form.medio == 'on') {
        return this.form.otros_medio
      }
      return this.form.medio
    },
    com_genero() {
      if (this.form.genero == 'on') {
        return this.form.otros_genero
      }
      return this.form.genero
    },
    com_grupointeres() {
      if (this.form.grupointeres == 'on') {
        return this.form.otros_grupointeres
      }
      return this.form.grupointeres
    },
  },
}
</script>
